<template>
    <div>
        <v-snackbar
            v-for="(alert, index) in visibleAlerts"
            :key="alert.id"
            v-model="alert.visible"
            :color="alert.type"
            :close-delay="alert.timeout"
            variant="flat"
            :style="{ bottom: `${index * 60}px` }"
        >
            <div>
                <strong>{{ alert.alertTitle }}</strong>
                <span class="mr-2 ml-2">|</span>
                <span>{{ alert.alertMessage }}</span>
            </div>
            <template v-slot:actions>
                <v-btn
                    variant="text"
                    density="compact"
                    color="white"
                    icon="mdi-close-circle"
                    @click.prevent.stop="alert.visible = false"
                />
            </template>
        </v-snackbar>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useCommonStore } from '@/stores/useCommonStore'
const storeCommon = useCommonStore()
const visibleAlerts = computed(() => {
    return storeCommon.alerts.filter((alert) => alert.visible)
})
</script>
